import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { IconButton } from '@material-ui/core'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

import { CANCEL } from 'app/constants/button'
import PrimaryTooltip from 'app/componentV4/Tooltip/PrimaryTooltip'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const DeleteDraft = (props) => {
  const { onDelete, onDialog } = props
  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
    onDialog(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    onDialog(false)
  }

  return (
    <>
      <PrimaryTooltip
        title={formatMessage({
          id: 'action.delete',
        })}
      >
        <IconButton
          aria-label="Delete Button Icon"
          size="small"
          className="text-red-500"
          onClick={() => {
            handleOpen()
          }}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </PrimaryTooltip>
      <SubmitDialog
        id="dialog-delete-draft-timeline"
        open={isOpen}
        type={CANCEL}
        title={formatMessage({
          id: 'timeline.dialog.title.delete.draft',
        })}
        description={formatMessage({
          id: 'timeline.dialog.description.delete.draft',
        })}
        submitText={formatMessage({
          id: 'action.confirm',
        })}
        onSubmit={async () => {
          await onDelete()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </>
  )
}

DeleteDraft.propTypes = {
  className: PropTypes.string,
  onDelete: PropTypes.func,
  onDialog: PropTypes.func,
}

export default DeleteDraft
